import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon, IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {center} from '../../../../libs/shared/ui/src/styles/mixins';
import {PaletteColorsEnum} from '../../../../libs/shared/ui/src/styles/paletteModel';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {RPaletteColor} from '../../../models/api/paletteModelRuntime';

/*
 * Props.
 */

interface ApplicationCardIconAvatarProps {
  iconName: IconName;
  color: PaletteColorsEnum | string;
}

/*
 * Style.
 */

interface AvatarStyleProps {
  $iconColor: string;
}
const StyledAvatarDiv = styled.div<AvatarStyleProps>`
  align-self: center;
  padding: 5px;
  ${center()}

  border-radius: 15px 15px;
  color: ${(p) => p.theme.greys.white};
  background-color: ${(p) => p.$iconColor};
`;

/*
 * Component.
 */

export const ApplicationCardIconAvatar: FC<ApplicationCardIconAvatarProps> = (props) => {
  const {iconName, color} = props;
  const theme = useUserTheme();
  // If our color is a PaletteColorsEnum, use its shade40. Otherwise simply use the specified color.
  const iconColor = RPaletteColor.is(color) ? theme.palette[color].shade40 : color;

  return (
    <StyledAvatarDiv $iconColor={iconColor}>
      <Icon name={iconName} />
    </StyledAvatarDiv>
  );
};
